import * as Yup from "yup";
import { createPostSchema } from "./characterLimit";

export const schema = (maxCharacters: number) => createPostSchema(maxCharacters);

const today = new Date();
const futureMaxDate = new Date(today);
futureMaxDate.setMonth(futureMaxDate.getMonth() + 3);

export const partialSchema = Yup.object().shape({
  schedule_publish_at: Yup.date().when('action_publish_at', {
    is: 'scheduled_publication',
    then: Yup.date()
      .min(today, "Debes indicar una fecha futura")
      .max(futureMaxDate, "Puedes programar la publicacion hasta un máximo de 3 meses en el futuro")
      .required("Debes completar la fecha y hora en que quieres que se publique el artículo"),
    otherwise: Yup.date().nullable(),
  }),
});

interface FormValues {
  title: string;
  body: string;
  attached_files?: object[];
  attached_url?: string;
  content_categories?: number[];
  notificate_by_email: string[];
  notificate_by_telegram: string[];
  is_free: string[];
  group?: number;
  schedule_publish_at: string;
  action_publish_at: string;
  show_scheduled_post: string[];
  block_files_download: string[];
  short_description: string;
  ask_for_phone: string[];
}

export const initialValues: FormValues = {
  title: "",
  body: "",
  content_categories: [],
  notificate_by_email: ["true"],
  notificate_by_telegram: ["true"],
  is_free: [],
  schedule_publish_at: "",
  action_publish_at: "",
  show_scheduled_post: ["false"],
  block_files_download: [],
  short_description: "",
  ask_for_phone: [],
};